import { Link } from "react-router-dom";

interface CategoryEntry {
  to: string;
  icon: string;
  title: string;
  enTitle: string;
  description: string;
  count: string;
  image: string;
}

const entries: CategoryEntry[] = [
  {
    to: "/category?type=movie",
    icon: "ri-film-line",
    title: "电影推荐",
    enTitle: "Films",
    description: "院线新片、影展佳作与经典重映，按题材与口碑为你挑出值得走进影院的那一部。",
    count: "32 部在荐",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20empty%20movie%20theatre%20with%20warm%20amber%20screen%20glow%20and%20deep%20navy%20seats%2C%20atmospheric%20minimal%20composition%2C%20soft%20haze%2C%20high%20detail&width=900&height=600&seq=home-entry-movie&orientation=landscape",
  },
  {
    to: "/category?type=tv",
    icon: "ri-tv-2-line",
    title: "电视剧热播",
    enTitle: "Series",
    description: "本周热度剧集、连载更新提示与完结口碑榜，跟着追剧节奏一次不落。",
    count: "18 部在追",
    image:
      "https://readdy.ai/api/search-image?query=Cozy%20dim%20living%20room%20at%20night%20with%20a%20television%20emitting%20warm%20amber%20light%20and%20deep%20navy%20shadows%2C%20atmospheric%20minimal%20composition%2C%20high%20detail&width=900&height=600&seq=home-entry-tv&orientation=landscape",
  },
];

export default function CategoryEntries() {
  return (
    <section className="px-4 md:px-6 py-12 md:py-16 bg-background-50">
      <div className="max-w-[1440px] mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-6 md:mb-8">
          <div>
            <span className="text-xs tracking-[0.22em] uppercase text-secondary-600">Browse by</span>
            <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-950 mt-2">从这里开始浏览</h2>
          </div>
          <p className="text-sm text-foreground-500 max-w-md">两大内容板块，覆盖院线电影与热播剧集。全部作品支持题材、地区与年份组合筛选。</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
          {entries.map((entry) => (
            <Link
              key={entry.to}
              to={entry.to}
              className="group relative rounded-lg overflow-hidden h-[220px] md:h-[260px] cursor-pointer"
            >
              <img
                src={entry.image}
                alt={entry.title}
                title={`${entry.title} 星光传媒`}
                className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-primary-950/95 via-primary-950/75 to-primary-950/30"></div>
              <div className="relative z-10 h-full p-5 md:p-7 flex flex-col justify-between">
                <div className="flex items-start justify-between">
                  <span className="w-10 h-10 rounded-md bg-background-50/12 text-accent-300 flex items-center justify-center backdrop-blur-sm">
                    <i className={`${entry.icon} text-lg w-5 h-5 flex items-center justify-center`}></i>
                  </span>
                  <span className="text-[11px] px-2 py-1 rounded-full bg-background-50/10 text-background-200 backdrop-blur-sm">
                    {entry.count}
                  </span>
                </div>
                <div className="max-w-sm">
                  <p className="text-[11px] tracking-[0.22em] uppercase text-background-300/70 mb-1">{entry.enTitle}</p>
                  <h3 className="font-heading text-xl md:text-2xl font-medium text-background-50 mb-2">{entry.title}</h3>
                  <p className="text-xs md:text-sm text-background-300/85 leading-relaxed mb-3 line-clamp-2">{entry.description}</p>
                  <span className="inline-flex items-center gap-1 text-xs md:text-sm text-accent-300">
                    进入频道
                    <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center transition-transform group-hover:translate-x-1"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}